export const HOME = '/';
export const ABOUT = '/about';
export const ARTICLES = '/articles';
export const PROJECTS = '/projects';
export const USES = '/uses';
